import type { OrderFulfillmentStatus } from '@/types/order';

/**
 * Etiquetas de “estado de orden” para listados (PM): Pagada → En preparación → Despachado → Entregado.
 * El enum en BD mantiene EN_CAMINO; en UI el paso “Despachado” cubre envío en curso (EN_CAMINO) y despacho previo.
 */
const OPERATIONAL_I18N_KEY: Record<OrderFulfillmentStatus, string> = {
  EN_PREPARACION: 'orders.operationalDisplay_PAGADA',
  DESPACHADO: 'orders.operationalDisplay_EN_PREPARACION',
  EN_CAMINO: 'orders.operationalDisplay_DESPACHADO',
  ENTREGADO: 'orders.operationalDisplay_ENTREGADO',
};

export function operationalOrderStatusLabel(
  fulfillmentStatus: OrderFulfillmentStatus,
  t: (key: string) => string,
): string {
  const key = OPERATIONAL_I18N_KEY[fulfillmentStatus];
  const translated = t(key);
  return translated === key ? fulfillmentStatus : translated;
}
